import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // Kita akan buat file ini selanjutnya

createApp(App).use(router).mount('#app')